export default "https://storage.googleapis.com/prepweb-prod/dist/5c8bf5163ed00190b32a38be73dbe400.svg";